import React from "react";
import { Flame, MapPin } from "lucide-react";

export default function BoatHeroAd() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          BBQ Boat Hero Ad · 1080×1080
        </p>

        <div
          data-testid="boat-hero-ad"
          className="relative w-[540px] h-[540px] overflow-hidden bg-black"
        >
          {/* Hero food image */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: "url(/menu/bbq_boat_hero.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "saturate(1.15) contrast(1.05)",
            }}
          />
          {/* Top + bottom gradient — keep food visible in middle */}
          <div
            className="absolute inset-x-0 top-0 h-[35%]"
            style={{
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.4) 70%, transparent 100%)",
            }}
          />
          <div
            className="absolute inset-x-0 bottom-0 h-[40%]"
            style={{
              background:
                "linear-gradient(0deg, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.55) 60%, transparent 100%)",
            }}
          />
          {/* Ember rim */}
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at 50% 50%, transparent 35%, rgba(255,59,48,0.08) 80%)",
            }}
          />
          {/* Grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-25 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* TOP — brand + signature dish ribbon */}
          <div className="absolute top-0 left-0 right-0 z-10">
            {/* brand row */}
            <div className="px-6 pt-5 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Flame
                  className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.8)]"
                  style={{ width: 18, height: 18 }}
                />
                <span
                  className="font-['Anton'] uppercase text-white tracking-[0.3em]"
                  style={{ fontSize: 13 }}
                >
                  Smokey <span className="text-[#FF3B30]">AF</span>
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <MapPin className="w-3 h-3 text-[#FF8C00]" />
                <span
                  className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.4em]"
                  style={{ fontSize: 9 }}
                >
                  City of Fremont, NE
                </span>
              </div>
            </div>

            {/* Signature dish callout */}
            <div className="text-center mt-5 px-6">
              <div
                className="inline-block bg-[#FF3B30] text-white font-['Anton'] uppercase tracking-[0.4em] px-3 py-1"
                style={{ fontSize: 11 }}
              >
                The Signature Dish
              </div>
              <h1
                className="font-['Anton'] uppercase text-white leading-[0.82] mt-3 drop-shadow-[0_8px_25px_rgba(0,0,0,0.95)]"
                style={{ fontSize: 70, letterSpacing: "-0.02em" }}
              >
                The <span style={{ color: "#FF3B30" }}>BBQ Boat</span>
              </h1>
            </div>
          </div>

          {/* BOTTOM — description + price + CTA */}
          <div className="absolute inset-x-0 bottom-0 z-10 px-6 pb-6">
            <p
              className="text-center font-['Outfit'] italic text-zinc-100 leading-snug max-w-[440px] mx-auto"
              style={{ fontSize: 14 }}
            >
              Buttered, toasted steak rolls — light, airy, crisp. Slow-smoked
              pulled pork. Mild chipotle cheese. BBQ drizzle.
              <br />
              Creamy minced slaw on top.
            </p>

            <div className="mt-4 flex items-center justify-between">
              <div
                className="bg-[#FF3B30] text-white font-['Anton'] tracking-wider px-4 py-2 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.6)]"
                style={{ fontSize: 38 }}
              >
                $14
              </div>
              <span
                className="font-['Anton'] tracking-widest uppercase bg-white text-black px-4 py-2.5"
                style={{ fontSize: 13 }}
              >
                Order Online
              </span>
            </div>
            <div
              className="mt-2 text-center font-['Outfit'] uppercase text-zinc-400 tracking-[0.3em]"
              style={{ fontSize: 9 }}
            >
              Inside Southern Style Bar · 648 N Broad St · smokey-af-bbq.emergent.host
            </div>
          </div>
        </div>

        <a
          href="/ads/bbq_boat_hero_ad.png"
          download
          data-testid="boat-hero-dl"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
